import { render, staticRenderFns } from "./CaracteristicasPaciente.vue?vue&type=template&id=09ac1b68"
import script from "./CaracteristicasPaciente.vue?vue&type=script&lang=js"
export * from "./CaracteristicasPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports